<template>
  <bloemen />
</template>

<script>
import Bloemen from '../components/KeuzesUitvaart/Bloemen.vue'

export default {
  name: 'BloemenView',
  components: {
    Bloemen
  }
}
</script>
